// extracted by mini-css-extract-plugin
export default {"nameCaution":"NameCaution_nameCaution__xZjHQ"};